import { Link } from 'react-router-dom';

import { useRGetDigisignStatus } from 'repositories/merchant/loan';
import type { LoanResponse } from 'repositories/merchant/loan';

import { DIGISIGN_LINK } from './constants';

interface UseHandleCheckboxLabelProps extends Pick<LoanResponse, 'loanXid'> {
  isLoanInactive: boolean;
}

function useHandleCheckboxLabel(props: UseHandleCheckboxLabelProps) {
  const { loanXid, isLoanInactive } = props;

  const { data: digisignStatus } = useRGetDigisignStatus({
    loanXid,
    enabled: isLoanInactive,
  });

  const isDigisignRegistered = digisignStatus?.data.isRegistered;
  let checkboxLabel = (
    <>
      Saya telah membaca serta menyetujui SKRTP dan{' '}
      <Link
        className='digisign-link'
        to={{ pathname: DIGISIGN_LINK }}
        target='_blank'
      >
        tanda tangan digital
      </Link>
    </>
  );

  if (isDigisignRegistered) {
    checkboxLabel = <>Saya telah membaca dan menyetujui SKRTP di atas</>;
  }

  return checkboxLabel;
}

export default useHandleCheckboxLabel;
